import { until } from '@vueuse/core';
import { registerAnalyticsProviders, setAnalyticsTrackingEnabled } from '@/services/analytics';
import { store } from '@/plugins/pinia';
import { useAppConfigStore } from '@/stores/useAppConfigStore';
import { Ga4Analytics } from './providers/ga4';
import { GoogleTagManagerAnalytics } from './providers/googleTagManager';
import { MetaPixelAnalytics } from './providers/metaPixel';
import { TikTokPixelAnalytics } from './providers/tiktokPixel';

export function setupAnalytics(): void {
  registerAnalyticsProviders([
    new Ga4Analytics(),
    new MetaPixelAnalytics(),
    new TikTokPixelAnalytics(),
    new GoogleTagManagerAnalytics(),
  ]);
  void applyEnvironmentTracking();
}

async function applyEnvironmentTracking(): Promise<void> {
  // Local SDK testing opts in explicitly; deployed environments follow their backend config.
  if (import.meta.env.VITE_ENABLE_ANALYTICS === 'true') {
    setAnalyticsTrackingEnabled(true);
    return;
  }
  const appConfigStore = useAppConfigStore(store);
  await until(() => appConfigStore.isLoaded).toBe(true);
  setAnalyticsTrackingEnabled(appConfigStore.trackingEnabled);
}
